<template>
  <div class="spinner">
    <font-awesome-icon icon="spinner" class="rotate_balance" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  //   border: 1px solid red;
  //   color: #fff8;
    // border-radius: 50%;
  //   background: rgba(0, 0, 0, 0.2);
    // box-shadow: 0px 0px 40px 40px rgba(0, 0, 0, 0.75);

//   &:after {
//     content: "";
//     width: 0px;
//     height: 0px;
//     position: absolute;
//     left: 50%;
//     top: 50%;
//     transform: translate(-50%, -50%);
//     border-radius: 50%;
//     // background: red; // rgba(0, 0, 0, 0.2);
//     box-shadow: 0px 0px 40px 20px rgba(0, 0, 0, 0.75);
//   }

  .rotate_balance {
    //   opacity: 0;
    font-size: 60px;
    animation: rotation 1s infinite linear,
      balance 1s infinite linear alternate-reverse;
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

@keyframes balance {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.1;
  }
}
</style>